export const IN_USER = "IN_USER";
export const GET_CLIENT = "GET_CLIENT";
export const GET_VERIFYS = "GET_VERIFYS";
export const GET_ENROLLS = "GET_ENROLLS";
export const GET_COLLEAGUES = "GET_COLLEAGUES";
export const UPDATE_COLLEAGUES = "UPDATE_COLLEAGUES";
export const ACTION_COLLEAGUES = "ACTION_COLLEAGUES";
export const DELETE_COLLEAGUES = "DELETE_COLLEAGUES";
